/**
 * strongly typed stringification of note placement info (as opposed to using
 * JSON.stringify directly, which would allow typos to type check without
 * fail).
 */
function stringifyNotePlacementInfo(placementInfo) {
  return JSON.stringify(placementInfo);
}

export { stringifyNotePlacementInfo };
//# sourceMappingURL=stringifyNotePlacementInfo.js.map
